import React, { useState } from "react";
import { Button, Card, Input, Select } from "antd";
import { useCreateInvitationMutation } from "../../invitation/invitationApi"
import { toast } from "react-toastify";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
const initFormValue = {
    email: "",
    name: "",
    emp_type: "EM",
};
export default function UserInviteView() {
    const [createInvitation, { isLoading, data }] = useCreateInvitationMutation();
    const [formValue, setFormValue] = useState(initFormValue);
    const { Option } = Select;
    const handleSubmit = (e) => {
        e.preventDefault();
        createInvitation(formValue);
        // createInvitation({ email, name, emp_type });
        toast.success("User Invited Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          toastId: "1"
        });
    };
    const handleChange = (e) => {
      if (typeof e === "string") {
        setFormValue({ ...formValue, emp_type: e });
        return;
      }
      const id = e.target?.dataset?.id;
      if (id) setFormValue({ ...formValue, [id]: e.target.value });
    };
  
    return (
      <div className="flex justify-center">
        <Card title="Invite User" style={{ width: "80%" }}>
          <div className="flex justify-center py-6">
            <form className="flex flex-col w-72 gap-4" onSubmit={handleSubmit}>
              <Input
                data-id="name"
                placeholder="Name"
                prefix={<UserOutlined />}
                onChange={handleChange}
              />
              <br />
              <Input
                data-id="email"
                onChange={handleChange}
                prefix={<MailOutlined />}
                type="email"
                placeholder="Email"
              />
  
              <Select
                showSearch
                placeholder="Employee Type"
                optionFilterProp="children"
                onChange={handleChange}
              >
                <Option value="EM">Employee</Option>
                <Option value="HR">Manager</Option>
              </Select>
              <Button onClick={handleSubmit} loading={isLoading}>
                Invite
              </Button>
            </form>
          </div>
        </Card>
      </div>
    );
  }